import React, { useState } from "react"
import { Link } from "gatsby"
import { Helmet } from "react-helmet"

import Nav from "./nav"
import NavSticky from "./navsticky"
import NavItems from "./navitems"
import Seo from "./seo"
import Logo from "../static/images/logo.svg"

export default function Header({ pageTitle = null }) {
  const [isBurgerMenuActive, setIsBurgerMenuActive] = useState(false)
  const [isUlMenuActive, setIsUlMenuActive] = useState(false)

  const menuHandler = () => {
    setIsBurgerMenuActive(!isBurgerMenuActive)
    setIsUlMenuActive(!isUlMenuActive)
  }
  return (
    <>
      {isBurgerMenuActive && (
        <Helmet
          bodyAttributes={{
            class: "body noScroll",
          }}
        />
      )}
      <Seo title={pageTitle} />
      <header class="c-header c-header-sm">
        <div class="container">
          <div class="row">
            <div class="col-12">
              <div class="c-header__main-info c-header__main-info-sm">
                <div class="c-header__main-info--logo c-header__main-info--logo-sm">
                  {/* Link labelled "Home" (matching the nav/footer home links to
                      "/" for WCAG 3.2.4 Consistent Identification); the logo image
                      is decorative (alt="") so it is not a redundant image and the
                      link name is not image-derived (WCAG 1.1.1). */}
                  <Link to="/" aria-label="Home">
                    <img src={Logo} class="image-fluid" alt="" />
                  </Link>
                </div>
                <Nav />
                <button
                  type="button"
                  class={`c-sticky-hamMenu js-hamDevice burger ${
                    isBurgerMenuActive ? `active` : ``
                  }`}
                  aria-label={isBurgerMenuActive ? "Close menu" : "Open menu"}
                  aria-expanded={isBurgerMenuActive}
                  aria-controls="responsiveMenu"
                  onClick={menuHandler}
                >
                  <span class="transition-med" aria-hidden="true"></span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* <!-- Begin Mobile Menu --> */}
      <nav
        class={`responsive--menu ${isUlMenuActive ? `is--active` : ``}`}
        id="responsiveMenu"
        aria-label="Mobile navigation"
      >
        <ul class="mainNav">
          <NavItems isMobile={true} onMenuItemClick={menuHandler} />
        </ul>
      </nav>
      <div class="responsive--menu-overlay"></div>
      {/* <!-- //End Mobile Menu --> */}

      {/* <!-- Begin Sticky Nav --> */}
      <NavSticky onMenuClick={menuHandler} isUlMenuActive={isUlMenuActive} />
      {/* <!-- //End Sticky Nav --> */}
    </>
  )
}
